import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddPbxItem({ account, accountDispatch, pbx }) {
  const [pending, setPending] = useState(false);

  const addPbxToAccount = (pbx) => {
    setPending(true);
    Promise.resolve(Api.postAccountToPbx(account, pbx))
      .then(() => accountDispatch({ type: "addPbx", value: pbx }))
      .finally(() => setPending(false));
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton onClick={() => addPbxToAccount(pbx)} disabled={pending} sx={{ minHeight: 44 }}>
        <ListItemAvatar>
          <Avatar text={pbx.name} />
        </ListItemAvatar>
        <ListItemText primary={pbx.name} secondary={pbx.context} />
        {pending && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={viSpinnerThird} spin />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddPbxItem.propTypes = {
  account: PropTypes.object,
  accountDispatch: PropTypes.func,
  pbx: PropTypes.object,
};

export default AddPbxItem;
